import {
  Kamoku,
  HasId,
  ResponseSettingItem,
  ShokushuKmkTypeType,
  ShokushuTypeType, shokushuKmkTypeType, shokushuTypeType, WorkTypeType, workTypeType
} from '@/repositories/keiei-joho/data'
import { CorporationInfoData, FacilityInfoData } from '@/repositories/commons/corporationInfoRepository'

export type ResponseShokushuSettingItem = HasId & {
  kmkName: string;
  kmkType: ShokushuKmkTypeType;
  shokushuType: ShokushuTypeType;
  isRequiredSetting: boolean;
  conflictGroup: string;
  conflictSide: string;
  setting: ResponseSettingItem;
}

export type ResponseShokushuSetting = {
  kamokuSources: Kamoku[],
  items: ResponseShokushuSettingItem[]
}

export type CorporationInfoPick = Pick<CorporationInfoData, 'corporateName' | 'medicalCorporationNumber' | 'corporationNumber'>
export type FacilityInfoPick = Pick<FacilityInfoData,
  'facilityKey' | 'displayOrder' | 'hospitalClinicKbn' | 'hospitalClinicName' | 'hasBedOutpatientMgmtNumber' | 'bedOutpatientMgmtNumber' |
  'hasMedicalInstitutionCode' | 'medicalInstitutionCode' | 'executiveCount' | 'staffCount' | 'prefecture' |
  'municipality' | 'townArea' | 'secondaryMedicalArea' | 'hasBedFunctionReport'>
export type FacilityInfoPickPick = Pick<FacilityInfoPick, 'facilityKey' | 'displayOrder' | 'hospitalClinicName' | 'hospitalClinicKbn'>

export interface HasKin {
  kin: number | null;
}

export type ShokushuKmkType = HasKin & {
  kmkName: string;
  kmkType: ShokushuKmkTypeType;
  shokushuType: ShokushuTypeType;
  workType: WorkTypeType;
  isNinzuKmk: boolean;
  conflictGroup: string;
  conflictSide: string;
  exportKmkName: string;
}
export function initializeShokushuKmk (): ShokushuKmkType {
  return {
    kmkName: '',
    kmkType: shokushuKmkTypeType.DoctorJokinKyuryo,
    shokushuType: shokushuTypeType.Doctor,
    workType: workTypeType.Jokin,
    isNinzuKmk: false,
    conflictGroup: '',
    conflictSide: '',
    exportKmkName: '',
    kin: 0
  }
}

export type ResponseShokushuRegisterLayout = {
  corporationInfo: CorporationInfoPick,
  facilityInfo: FacilityInfoData,
  kmkTypes: ShokushuKmkType[]
}

export type ResponseShokushuShukeiData = {
  kmkType: ShokushuKmkTypeType,
  isNinzuKmk: boolean,
  kin: number | null
}
